<script>
import { ExclamationCircleIcon } from '@heroicons/vue/20/solid'

export default {
    components: {
        ExclamationCircleIcon
    },

    emits: ['update:modelValue'],

    props: {
        label: {
            type: String,
        },

        id: {
            type: String,
            required: true
        },

        error: {
            type: String,
            default: ''
        },

        placeholder: {
            type: String,
            default: ''
        },

        modelValue: {
            type: [String, Number]
        }
    }
}
</script>

<template>
    <div v-auto-animate>
        <label :for="id" class="block text-base text-text-300 font-medium" v-if="label">{{ label }}</label>

        <div class="relative mt-1 rounded-md" v-auto-animate>
            <textarea :name="id" :id="id" :class="[error ? 'error' : '']"
                class="block w-full rounded-md pr-10 py-3 font-bi-text-medium placeholder:font-bi-text text-base text-bi-dark-green placeholder-bi-gray-60 border-bi-warm-gray border-2 focus:outline-none shadow-none focus:border-bi-accent-green ring-0 focus:ring-0 bg-bi-white"
                :placeholder="placeholder" :aria-invalid="!error ? 'false' : 'true'" :aria-describedby="`${id}-error`"
                :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" v-if="error">
                <ExclamationCircleIcon class="h-5 w-5 text-red-500" aria-hidden="true" />
            </div>
        </div>

        <p class="mt-2 text-base" :id="`${id}-error`" v-if="error">
            {{ error }}
        </p>
    </div>
</template>
